import { render, staticRenderFns } from "./NovaMudancaHorario.vue?vue&type=template&id=7d6bba1e&"
import script from "./NovaMudancaHorario.vue?vue&type=script&lang=js&"
export * from "./NovaMudancaHorario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports